module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "readmore"
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOptions
    }
  }, [_vm._l((_vm.articles), function(article) {
    return _c('swiper-slide', {
      key: article.title
    }, [_c('a', {
      staticClass: "readmore-element",
      attrs: {
        "href": article.url
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          _vm.openArticle(article.slug)
        }
      }
    }, [_c('img', {
      staticClass: "readmore-element-img",
      attrs: {
        "src": article.media[_vm.thumbnail_size].url,
        "alt": article.media[_vm.thumbnail_size].alt
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "readmore-element-title",
      domProps: {
        "innerHTML": _vm._s(article.title)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "readmore-element-date"
    }, [_vm._v(_vm._s(article.formatted_date))]), _vm._v(" "), _c('div', {
      staticClass: "readmore-element-tag"
    }, [_c('tags', {
      attrs: {
        "categories": article.categories,
        "size": "small"
      }
    })], 1)])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Chevron_thin_left",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 20",
      "enable-background": "new 0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M13.891,17.418c0.268,0.272,0.268,0.709,0,0.979s-0.701,0.271-0.969,0l-7.83-7.908\n                c-0.268-0.27-0.268-0.707,0-0.979l7.83-7.908c0.268-0.27,0.701-0.27,0.969,0c0.268,0.271,0.268,0.709,0,0.979L6.75,10L13.891,17.418\n                z"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  }, [_c('svg', {
    attrs: {
      "version": "1.1",
      "id": "Chevron_thin_right",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 20 20",
      "enable-background": "new 0 0 20 20",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#FFFFFF",
      "d": "M13.25,10L6.109,2.58c-0.268-0.27-0.268-0.707,0-0.979c0.268-0.27,0.701-0.27,0.969,0l7.83,7.908\n                c0.268,0.271,0.268,0.709,0,0.979l-7.83,7.908c-0.268,0.271-0.701,0.27-0.969,0c-0.268-0.269-0.268-0.707,0-0.979L13.25,10z"
    }
  })])])], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02087e77"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/article/readmore.vue
// module id = 161
// module chunks = 4